//import React, { useContext, useEffect, useState } from "react";
import React, { useContext, useEffect, useState, useRef } from "react";
import { useTranslation } from "react-i18next";

import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControlLabel,
  MenuItem,
  Radio,
  RadioGroup,
  TextField,
  Typography,
  styled,
} from "@mui/material";
import { MdCameraAlt, MdFileDownload } from "react-icons/md";
import { ImAttachment } from "react-icons/im";
import { DragNDrop } from "../../../components";
import { createVisitSheet, getFinca, getStatement } from "../../../services";
import { withRouter } from "../../../providers/withRouter";
import { UsuarioContext } from "../../../providers/userContext";
import { comprimirImagen, comprimirImagenOld, formatoFechas } from "../../../functions/funciones";
import { toast } from "react-toastify";
import CustomImageList from "../../../components/ImageList/CustomImageList";
import { verificarFecha } from "../../../functions/validator/formValidator";
import Portales from "../../../components/Comunidad/portales";
import { useVisitQueue, clasificarRespuestaVisita } from "../../../providers/visitQueueContext";
import { construirBackupBlob, descargarBlobLocal } from "../../../utilities/visitBackup";
import { getEntry, getDraft, putDraft, deleteDraft } from "../../../utilities/visitQueueDB";

const obtenerStorageKey = (nif, id, idCentroTrabajo) => {
  return `hojaVisita_${nif}_${id}${idCentroTrabajo ? `_${idCentroTrabajo}` : ''}`;
};

// Cache del listado de preguntas para poder editar una visita sin conexión
// (cuando getStatement no responde, se usa la última copia guardada).
const STATEMENTS_CACHE_KEY = 'statementsCache';

const guardarStatementsCache = (statements) => {
  try {
    if (Array.isArray(statements) && statements.length > 0) {
      localStorage.setItem(STATEMENTS_CACHE_KEY, JSON.stringify(statements));
    }
  } catch (error) {
    console.error('Error guardando cache de preguntas:', error);
  }
};

const cargarStatementsCache = () => {
  try {
    const cache = localStorage.getItem(STATEMENTS_CACHE_KEY);
    return cache ? JSON.parse(cache) : null;
  } catch (error) {
    console.error('Error cargando cache de preguntas:', error);
    return null;
  }
};

const ColorButton = styled(Button)(() => ({
  color: "white",
  backgroundColor: "#92004D",
  "&:hover": {
    backgroundColor: "#92004D",
  },
}));

const getTiposEdificio = (t) => [
  {
    value: "edificio",
    label: t('visitForm.buildingTypes.building'),
  },
  {
    value: "garaje",
    label: t('visitForm.buildingTypes.garage'),
  },
];

const SubQuestion = ({
  question,
  checkBind,
  onChange,
  disabled = false,
  noTakes,
  t,
}) => {
  const [noTakesTrue, setNoTakesTrue] = useState(false);

  return (
    <Box className={`lae-flex lae-flex-column`} sx={{ gap: 0 }}>
      <Box>
        <Box sx={{ flex: 5 }}>
          <Typography>{question}</Typography>
        </Box>

        {!noTakesTrue && (
          <Box className="lae-flex lae-flex-row " sx={{ gap: 1, flex: 5 }}>
            <RadioGroup
              aria-labelledby="controlled"
              value={checkBind}
              disabled={disabled}
              sx={{ flexDirection: "row" }}
              onChange={(e) => {
                const checked = { target: { checked: e.target.value } };

                onChange(checked);
              }}
            >
              <FormControlLabel
                value="no"
                control={
                  <Radio
                    sx={{
                      color: "#92004D",
                      "&.Mui-checked": {
                        color: "#92004D",
                      },
                    }}
                  />
                }
                label={t('visitForm.radioOptions.no')}
              />
              <FormControlLabel
                value="si"
                control={
                  <Radio
                    sx={{
                      color: "#92004D",
                      "&.Mui-checked": {
                        color: "#92004D",
                      },
                    }}
                  />
                }
                label={t('visitForm.radioOptions.yes')}
              />
              {noTakes && (
                <FormControlLabel
                  value="np"
                  control={
                    <Radio
                      sx={{
                        color: "#92004D",
                        "&.Mui-checked": {
                          color: "#92004D",
                        },
                      }}
                    />
                  }
                  label={t('visitForm.radioOptions.notApplicable')}
                />
              )}
            </RadioGroup>
          </Box>
        )}
      </Box>
    </Box>
  );
};

function Comunidad(props) {
  const { t } = useTranslation(['properties', 'common']);
  const [formData, setFormData] = useState({
    aaff_id: "",
    work_id: "",
    tipo_edificio: "edificio",
    IdComunidad: "",
    comunidad: "",
    IdTecnicoPRL: "",
    tecnicoPRL: "",
    fechaVisita: formatoFechas(new Date()),
    numeroPlantas: "",
    comentarios: "",
    questions: {},
    portales:[],
    delPortales: [],
  });

  let esPregunta15Si = false;
  let esPregunta5_1Si = false;
  let esPregunta5_2Si = false;
  const [formErrors, setFormErrors] = useState({});
  const user = useContext(UsuarioContext);
  const { enqueue, removeEntry, addSent } = useVisitQueue();

  // Modal que aparece cuando el envío falla: reintentar / guardar en cola / descargar backup.
  const [colaModalOpen, setColaModalOpen] = useState(false);
  const [reintentando, setReintentando] = useState(false);
  const datosPendientesRef = useRef(null);
  // Último resultado del intento fallido (para el detalle del backup).
  const ultimoResultadoRef = useRef(null);
  // Backup ya construido y listo para descargar/compartir. Se prepara ANTES de
  // que el usuario pulse el botón para no perder la activación del gesto en iOS.
  const backupRef = useRef(null);
  const [backupPreparando, setBackupPreparando] = useState(false);
  const [descargandoBackup, setDescargandoBackup] = useState(false);

  const [imagenComunidad, setImagenComunidad] = useState(null);
  const [imagenUrl, setImagenUrl] = useState(null);

  const [imagenesComunidad, setImagenesComunidad] = useState([]);
  const [imagenesUrl, setImagenesUrl] = useState([]);
  const [finca, setFinca] = useState({});
  const [recargar, setRecargar] = useState({});
  const [imagesToDelete, setImagesToDelete] = useState([]);

  const [statement, setStatement] = useState([]);
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const [procesandoImagenes, setProcesandoImagenes] = useState(false);
  const [restaurandoImagenes, setRestaurandoImagenes] = useState(false);

  const saveTimeoutRef = useRef(null);
  // Conserva la fecha de creación del borrador (para la caducidad de 1 mes).
  const draftCreatedAtRef = useRef(null);
  // Si la visita ya está en la cola, ésta es la fuente única.
  const enColaRef = useRef(false);
  // Omite el guardado disparado por la restauración inicial (no es edición real).
  const omitirAutoguardadoRef = useRef(false);
  const cameraInputRef = useRef(null);
  const fileInputRef = useRef(null);
  const cameraInputMultiRef = useRef(null);
  const fileInputMultiRef = useRef(null);

  const esMovil = () => {
    const userAgent = navigator.userAgent.toLowerCase();
    const esMovilUserAgent = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent);
    const esPantallaPequena = window.innerWidth <= 768 || window.innerHeight <= 600;
    const esTactil = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    
    // Ver si cumple al menos 2 condiciones
    const indicadores = [esMovilUserAgent, esPantallaPequena, esTactil].filter(Boolean).length;
    
    return indicadores >= 2;
  };

  useEffect(() => {
    console.log(props.params)
    fetchData();
  }, [recargar]);

  // Autoguardado del borrador en IndexedDB (datos + imágenes). Sustituye al
  // antiguo borrador en localStorage, que no podía almacenar imágenes.
  useEffect(() => {
  // No guardar si el formData está vacío o es el estado inicial
  if (!formData.aaff_id || !formData.IdComunidad) {
    return;
  }

  // Limpiar timeout anterior
  if (saveTimeoutRef.current) {
    clearTimeout(saveTimeoutRef.current);
  }

  // Configurar nuevo timeout para guardar (datos + imágenes)
  saveTimeoutRef.current = setTimeout(() => {
    // Omitimos el guardado provocado por la restauración inicial.
    if (omitirAutoguardadoRef.current) {
      omitirAutoguardadoRef.current = false;
      return;
    }
    const { nif, id, idCentroTrabajo } = props.params;
    const storageKey = obtenerStorageKey(nif, id, idCentroTrabajo);

    // La visita ya está en la cola: actualizamos esa misma entrada
    // en lugar de crear un borrador, para no duplicar ni divergir.
    if (enColaRef.current) {
      enqueue({
        id: storageKey,
        type: "create",
        params: { nif, id, idCentroTrabajo },
        datos: construirDatos(),
        mainImage: imagenComunidad,
        images: imagenesComunidad,
        comunidad: formData.comunidad,
        tecnicoPRL: formData.tecnicoPRL,
      }).catch((e) =>
        console.error("Error actualizando la entrada de la cola:", e)
      );
      return;
    }

    if (!draftCreatedAtRef.current) {
      draftCreatedAtRef.current = Date.now();
    }
    putDraft({
      id: storageKey,
      params: { nif, id, idCentroTrabajo },
      datos: formData,
      mainImage: imagenComunidad,
      images: imagenesComunidad,
      createdAt: draftCreatedAtRef.current,
      updatedAt: Date.now(),
    }).catch((e) => console.error("Error guardando borrador en IndexedDB:", e));
  }, 1500); // Esperar tras el último cambio (texto o imágenes)

  // Cleanup del timeout
  return () => {
    if (saveTimeoutRef.current) {
      clearTimeout(saveTimeoutRef.current);
    }
  };
}, [formData, imagenComunidad, imagenesComunidad, props.params]);

  // Construye el esqueleto de respuestas a partir del listado de preguntas.
  const construirInitialQuestions = (statements) =>
    (statements || []).reduce((acc, s, index) => {
      acc[s.id] = {
        statements_id: s.id,
        respuesta: null,
        subquestions:
          index === 0
            ? (s.subpreguntas || []).reduce((subAcc, sub) => {
                subAcc[sub.id] = { statements_id: sub.id, respuesta: null };
                return subAcc;
              }, {})
            : {},
      };
      return acc;
    }, {});

  const fetchData = async () => {
    const { nif, id, idCentroTrabajo } = props.params;
    setRestaurandoImagenes(true);
    omitirAutoguardadoRef.current = true;

    const statementsCache = cargarStatementsCache();
    const statementsLocal =
      Array.isArray(statementsCache) && statementsCache.length > 0
        ? statementsCache
        : [];


    const storageKey = obtenerStorageKey(nif, id, idCentroTrabajo);
    let draft = null;
    let entryCola = null;
    try {
      draft = await getDraft(storageKey);
    } catch (e) {
      console.error("Error leyendo el borrador (IndexedDB):", e);
    }
    try {
      entryCola = await getEntry(storageKey);
    } catch (e) {
      console.error("Error leyendo la cola para precargar la visita:", e);
    }
    // Si la visita está en la cola, ésta es la fuente única de datos.
    const enCola = !!entryCola;
    enColaRef.current = enCola;
    if (enCola && draft) {
      try {
        await deleteDraft(storageKey);
      } catch (e) {
        /* noop */
      }
      draft = null;
    }

    // Conservamos la fecha de creación del borrador para la caducidad de 1 mes.
    draftCreatedAtRef.current = draft?.createdAt || null;

    const fuenteDatos = enCola ? entryCola.datos || null : draft?.datos || null;
    const mainImagen = enCola
      ? entryCola.mainImage ?? null
      : draft?.mainImage ?? null;
    const imagenesRestauradas =
      (enCola ? entryCola.images : draft?.images) || [];

    const work_id = idCentroTrabajo ? parseInt(idCentroTrabajo) : null;
    const nombreLocal = fuenteDatos?.comunidad || entryCola?.comunidad || "";
    const aaffIdLocal = fuenteDatos?.aaff_id ?? "";
    const comunidadIdLocal = fuenteDatos?.IdComunidad ?? "";

    const formDataInicial = {
      sale_id: Number(id),
      work_id,
      aaff_id: aaffIdLocal,
      IdComunidad: comunidadIdLocal,
      comunidad: nombreLocal,
      user_id: user.user_id,
      IdTecnicoPRL: user.id,
      tecnicoPRL: user.nombre + " " + user.apellidos,
      saleDate: formatoFechas(new Date()),
      questions: construirInitialQuestions(statementsLocal),
      portales: [],
      delPortales: [],
    };

    if (statementsLocal.length > 0) {
      setStatement(statementsLocal);
    }

    if (fuenteDatos) {
      const portalesGuardados = Array.isArray(fuenteDatos.portales) ? fuenteDatos.portales : [];
      const delPortalesGuardados = Array.isArray(fuenteDatos.delPortales) ? fuenteDatos.delPortales : [];
      setFormData((prev) => ({
        ...prev,
        ...formDataInicial,
        ...fuenteDatos,
        portales: portalesGuardados,
        delPortales: delPortalesGuardados,
        user_id: user.user_id,
        IdTecnicoPRL: user.id,
        tecnicoPRL: user.nombre + " " + user.apellidos,
      }));
    } else {
      setFormData((prev) => ({ ...prev, ...formDataInicial }));
    }

    // Imágenes restauradas desde el borrador o la cola (IndexedDB). Local → rápido.
    if (mainImagen) {
      setImagenComunidad(mainImagen);
      setImagenUrl(URL.createObjectURL(mainImagen));
    }
    if (Array.isArray(imagenesRestauradas) && imagenesRestauradas.length > 0) {
      setImagenesComunidad(imagenesRestauradas);
      setImagenesUrl(
        imagenesRestauradas.map((img, i) => ({
          indice: i,
          id: i,
          img: URL.createObjectURL(img),
        }))
      );
    }
    setRestaurandoImagenes(false);

    let resFinca = null;
    try {
      resFinca = await getFinca(nif);
    } catch (e) {
      console.error("getFinca falló, se usan datos locales:", e);
    }

    let resStatement = null;
    try {
      resStatement = await getStatement();
    } catch (e) {
      console.error("getStatement falló, se usa la cache local:", e);
    }

    if (Array.isArray(resStatement) && resStatement.length > 0) {
      guardarStatementsCache(resStatement);
      setStatement(resStatement);
      if (!fuenteDatos) {
        setFormData((prev) => ({
          ...prev,
          questions: construirInitialQuestions(resStatement),
        }));
      }
    }

    if (resFinca) {
      setFinca(resFinca);
      const nombreReal = idCentroTrabajo
        ? resFinca.workcenters?.find((ct) => ct.id === Number(idCentroTrabajo))?.razonSocial
        : resFinca.razonSocial;
      setFormData((prev) => ({
        ...prev,
        aaff_id: resFinca.aaff?.id ?? prev.aaff_id,
        IdComunidad: resFinca.id ?? prev.IdComunidad,
        comunidad: nombreReal || prev.comunidad,
      }));
    }
  };

  const comprimirConTimeout = async (file) => {

    const comprimirImagenOldConTimeout = (file) => {
      return new Promise((resolve, reject) => {
        let terminado = false;
        const timerOld = setTimeout(() => {
          if (!terminado) {
            terminado = true;
            //toast.error("La compresión de la imagen ha tardado demasiado (10s). Prueba con otra imagen.");
            reject(new Error("Timeout en compresión antigua"));
          }
        }, 10000);
        comprimirImagenOld(file)
          .then((blob) => {
            if (!terminado) {
              terminado = true;
              clearTimeout(timerOld);
              resolve(blob);
            }
          })
          .catch((err) => {
            terminado = true;
            clearTimeout(timerOld);
            toast.error(t('visitForm.toast.compressionError'));
            reject(err);
          });
      });
    };

    return new Promise(async (resolve, reject) => {
      let terminado = false;
      const timer = setTimeout(async () => {
        if (!terminado) {
          terminado = true;
          try {
            const blobOld = await comprimirImagenOldConTimeout(file);
            resolve(blobOld);
          } catch (err) {
            reject(err);
          }
        }
      }, 20000);

      try {
        const blob = await comprimirImagen(file);
        if (!terminado) {
          terminado = true;
          clearTimeout(timer);
          resolve(blob);
        }
      } catch (err) {
        clearTimeout(timer);
        try {
          const blobOld = await comprimirImagenOldConTimeout(file);
          resolve(blobOld);
        } catch (errOld) {
          reject(errOld);
        }
      }
    });
  };

  const handleUploadImg = async (files) => {
    if (procesandoImagenes) return;
    if (!files || files.length === 0) return;
    
    const primeraImg = files[0];
    
    const extension = primeraImg.name.toLowerCase().split('.').pop();
    const extensionesValidas = ['jpg', 'jpeg', 'png', 'webp'];
    const tiposPermitidos = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp', 'image/pjpeg'];
    
    const esValidoPorTipo = tiposPermitidos.includes(primeraImg.type);
    const esValidoPorExtension = extensionesValidas.includes(extension);
    
    if (!esValidoPorTipo && !esValidoPorExtension) {
      toast.error(`${t('visitForm.toast.invalidImageFormat')} (${primeraImg.type})`);
      return;
    }

    setProcesandoImagenes(true);

    try {
      
      if (primeraImg.size <= 500 * 1024) {
        const imageUrl = URL.createObjectURL(primeraImg);
        setImagenComunidad(primeraImg);
        setImagenUrl(imageUrl);
      } else {
        const blob = await comprimirConTimeout(primeraImg);
        const nombreArchivo = primeraImg.name.split('.').slice(0, -1).join('.') + '.webp';
        const fileComprimido = new File([blob], nombreArchivo, { type: 'image/webp' });
        const imageUrl = URL.createObjectURL(fileComprimido);
        setImagenComunidad(fileComprimido);
        setImagenUrl(imageUrl);
      }
    } catch (err) {
      console.error(`Error procesando imagen individual ${primeraImg.name}:`, err);
      toast.error(`${t('visitForm.toast.processingError')} ${primeraImg.name}: ${err.message}`);
    } finally {
      setProcesandoImagenes(false);
    }
  };

  const handleUploadImgs = async (files) => {
    if (procesandoImagenes) return;
    if (!files || files.length === 0) return;
    
    const dispositivoMovil = esMovil();
    const fotosAProcesar = Array.from(files).slice(0, 20);
    
    if (files.length > 20) {
      return toast.error(t('visitForm.toast.maxImagesExceeded'));
    }

    const archivosValidos = fotosAProcesar.filter(file => {
      console.log(`Validando archivo: ${file.name}, tipo: ${file.type}, tamaño: ${(file.size / 1024 / 1024).toFixed(2)}MB`);
      
      const extension = file.name.toLowerCase().split('.').pop();
      const extensionesValidas = ['jpg', 'jpeg', 'png', 'webp'];
      const tiposPermitidos = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp', 'image/pjpeg'];
      
      const esValidoPorTipo = tiposPermitidos.includes(file.type);
      const esValidoPorExtension = extensionesValidas.includes(extension);
      
      if (!esValidoPorTipo && !esValidoPorExtension) {
        toast.error(`${file.name} ${t('visitForm.toast.invalidFile')} (${file.type})`);
        return false;
      }
      
      if (file.size > 50 * 1024 * 1024) {
        toast.error(`${file.name} ${t('visitForm.toast.fileTooLarge')}`);
        return false;
      }
      
      return true;
    });

    if (archivosValidos.length === 0) {
      toast.error(t('visitForm.toast.noValidFiles'));
      return;
    }

    console.log(`Dispositivo: ${dispositivoMovil ? 'Móvil' : 'Ordenador'} - Archivos válidos: ${archivosValidos.length} de ${fotosAProcesar.length}`);

    setProcesandoImagenes(true);
    const nuevasImagenes = [];
    let procesadasExitosamente = 0;
    let erroresEncontrados = 0;
    
    try {
      if (dispositivoMovil) {
        for (let i = 0; i < archivosValidos.length; i++) {
          const file = archivosValidos[i];
          try {
            if (file.size <= 500 * 1024) {
              nuevasImagenes.push(file);
              procesadasExitosamente++;
            } else {
              const blob = await comprimirConTimeout(file);
              const nombreArchivo = file.name.split('.').slice(0, -1).join('.') + '.webp';
              const fileComprimido = new File([blob], nombreArchivo, { type: 'image/webp' });
              nuevasImagenes.push(fileComprimido);
              procesadasExitosamente++;
              //console.log(`Imagen comprimida: ${nombreArchivo}`);
            }
          } catch (err) {
            erroresEncontrados++;
            console.error(`Error procesando ${file.name}:`, err);
            toast.error(`${t('visitForm.toast.processingError')} ${file.name}: ${err.message}`);
          }
        }
      } else {
        // Modo PC (en paralelo (más rápido))
        await Promise.all(
          archivosValidos.map(async (file) => {
            try {
                //console.log(`Procesando imagen: ${file.name} (${(file.size / 1024 / 1024).toFixed(2)}MB)`);
              if (file.size <= 500 * 1024) {
                nuevasImagenes.push(file);
                procesadasExitosamente++;
              } else {
                const blob = await comprimirConTimeout(file);
                const nombreArchivo = file.name.split('.').slice(0, -1).join('.') + '.webp';
                const fileComprimido = new File([blob], nombreArchivo, { type: 'image/webp' });
                nuevasImagenes.push(fileComprimido);
                procesadasExitosamente++;
              }
            } catch (err) {
              erroresEncontrados++;
              console.error(`Error procesando ${file.name}:`, err);
              toast.error(`${t('visitForm.toast.processingError')} ${file.name}: ${err.message}`);
            }
          })
        );
      }

      if (nuevasImagenes.length > 0) {
        setImagenesComunidad((prevImagenes) => [...prevImagenes, ...nuevasImagenes]);
        setImagenesUrl((prevUrls) => [
          ...prevUrls,
          ...nuevasImagenes.map((img, i) => ({
            indice: prevUrls.length + i,
            id: prevUrls.length + i,
            img: URL.createObjectURL(img),
          })),
        ]);
      }

      if (procesadasExitosamente > 0 && erroresEncontrados > 0) {
          toast.warn(`${procesadasExitosamente} ${t('visitForm.toast.imagesProcessed')}, ${erroresEncontrados} ${t('common:errors.errors')}`);
      } else if (procesadasExitosamente > 0) {
        toast.success(procesadasExitosamente > 1 ? `${procesadasExitosamente} ${t('visitForm.toast.imagesProcessed')}` : `1 ${t('visitForm.toast.imageProcessed')}`);
      } else if (erroresEncontrados > 0) {
        toast.error(t('visitForm.toast.imageProcessError'));
      }

    } catch (err) {
      console.error("Error general en handleUploadImgs:", err);
      toast.error(t('visitForm.toast.generalImageError'));
    } finally {
      setProcesandoImagenes(false);
    }

    // files.map((file) => {
    //   comprimirImagen(file, 14).then(res =>{
    //     setImagenesComunidad([...imagenesComunidad, res])
    //     setImagenesUrl([...imagenesUrl, URL.createObjectURL(res)])
    //   })
    // });
  };
  const validatePortales = (portales) => {
    if (!Array.isArray(portales)) return [];
    return portales.map((portal) => ({
      nombre: !portal.nombre?.trim(),
      numEscaleras: !portal.numEscaleras,
      numVecinos: !portal.numVecinos,
    }));
  };

  const validateForm = () => {
    const requiredFields = ["comentarios","numeroPlantas", "fechaVisita", "questions"];
    const newErrors = {};

    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = t('visitForm.validation.requiredField');
      }
    });

    const fechaCorrecta = verificarFecha(formData.fechaVisita);
    if (fechaCorrecta === false) {
      toast.error(t('visitForm.validation.invalidDateFuture'));
      newErrors.fechaVisita = t('visitForm.validation.invalidDateFuture');
    }

    if (!imagenComunidad) {
      newErrors.imagenPrincipal = t('visitForm.validation.missingMainImage');
    }

    if (!props.params.idCentroTrabajo) {
      const portalesErrors = validatePortales(formData.portales || []);
      const portalesValidos = formData.portales?.filter(portal => 
        portal && !portal.del && portal.nombre?.trim() && portal.numEscaleras && portal.numVecinos
      ) || [];
      if (portalesValidos.length === 0) {
        newErrors.portales = t('visitForm.validation.requiredPortal');
        newErrors.portalesErrors = portalesErrors;
      } else if (portalesErrors.some(err => err.nombre || err.numEscaleras || err.numVecinos)) {
        newErrors.portales = t('visitForm.validation.portalErrors');
        newErrors.portalesErrors = portalesErrors;
      }
    }

    let algunaPreguntaPrincipalSinRespuesta = false;
    let algunaSubpreguntaSinRespuesta = false;

    const idsVisibles = new Set(
      statement
        .filter((s) => formData.tipo_edificio !== "garaje" || s.codigo === 4)
        .map((s) => String(s.id))
    );

    Object.keys(formData.questions || {}).forEach((questionId) => {
      if (!idsVisibles.has(String(questionId))) return;
      const question = formData.questions[questionId];
      if (!question.respuesta) {
        algunaPreguntaPrincipalSinRespuesta = true;
        newErrors.question = "faltan preguntas";
      }

      if (question.respuesta === "si") {
        const subquestions = formData.questions[questionId].subquestions || {};
        Object.keys(subquestions).forEach((subquestionId) => {
          const subquestion = subquestions[subquestionId];
          if (!subquestion.respuesta) {
            algunaSubpreguntaSinRespuesta = true;
            newErrors.subquestion = "faltan subpreguntas";
          }
        });
      }
    });

    if (algunaPreguntaPrincipalSinRespuesta || algunaSubpreguntaSinRespuesta) {
      toast.error(t('visitForm.validation.missingQuestions'));
    } else if (
      !algunaPreguntaPrincipalSinRespuesta &&
      !algunaSubpreguntaSinRespuesta &&
      newErrors.imagenPrincipal
    ) {
      toast.error(t('visitForm.validation.missingMainImage'));
    }

    setFormErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Construye el objeto de datos filtrado que se envía al servidor / cola.
  const construirDatos = () => {
    const idsVisibles = new Set(
      statement
        .filter((s) => formData.tipo_edificio !== "garaje" || s.codigo === 4)
        .map((s) => String(s.id))
    );
    const questionsFiltradas = Object.fromEntries(
      Object.entries(formData.questions || {}).filter(([qid]) =>
        idsVisibles.has(String(qid))
      )
    );
    return { ...formData, questions: questionsFiltradas };
  };

  const enviarAlServidor = (datos) =>
    createVisitSheet(datos, imagenesComunidad, imagenComunidad, props.params.nif);

  const finalizarExito = (toastInfo) => {
    const { nif, id, idCentroTrabajo } = props.params;
    deleteDraft(obtenerStorageKey(nif, id, idCentroTrabajo));
    removeEntry(obtenerStorageKey(nif, id, idCentroTrabajo));
    addSent({
      id: obtenerStorageKey(nif, id, idCentroTrabajo),
      comunidad: formData.comunidad,
      tecnicoPRL: formData.tecnicoPRL,
      userId: user.id,
      userName: `${user.nombre || ""} ${user.apellidos || ""}`.trim(),
      sentAt: Date.now(),
    });
    window.history.back();
    toast.update(toastInfo, {
      render: t('visitForm.toast.dataSavedSuccess'),
      type: toast.TYPE.SUCCESS,
      autoClose: true,
    });
  };

  // Guarda la visita (datos + imágenes) en la cola de IndexedDB.
  const guardarEnCola = async (datos) => {
    const { nif, id, idCentroTrabajo } = props.params;
    const storageKey = obtenerStorageKey(nif, id, idCentroTrabajo);
    await enqueue({
      id: storageKey,
      type: "create",
      params: { nif, id, idCentroTrabajo },
      datos,
      mainImage: imagenComunidad,
      images: imagenesComunidad,
      comunidad: formData.comunidad,
      tecnicoPRL: formData.tecnicoPRL,
    });
    // A partir de aquí la cola es la fuente única y borramos el borrador.
    try {
      await deleteDraft(storageKey);
    } catch (e) {
      /* noop */
    }
    enColaRef.current = true;
  };

  // Construye la "entrada" (mismo formato que la cola) para generar el backup.
  const construirEntryBackup = (datos) => {
    const { nif, id, idCentroTrabajo } = props.params;
    return {
      id: obtenerStorageKey(nif, id, idCentroTrabajo),
      type: "create",
      params: { nif, id, idCentroTrabajo },
      datos,
      mainImage: imagenComunidad,
      images: imagenesComunidad,
      comunidad: formData.comunidad,
      tecnicoPRL: formData.tecnicoPRL,
      userId: user?.id ?? null,
      userName: `${user?.nombre || ""} ${user?.apellidos || ""}`.trim(),
    };
  };

  // Prepara el .zip de backup por adelantado (el usuario aún no ha pulsado nada).
  // Así, al pulsar "Descargar backup", la descarga/compartir sale directa del
  // gesto y iOS no la bloquea.
  const prepararBackup = async (datos) => {
    setBackupPreparando(true);
    backupRef.current = null;
    try {
      const entry = construirEntryBackup(datos);
      const { blob, filename } = await construirBackupBlob(
        entry,
        ultimoResultadoRef.current
      );
      backupRef.current = { blob, filename };
    } catch (e) {
      console.error("Error preparando el backup de la visita:", e);
    } finally {
      setBackupPreparando(false);
    }
  };

  // Modal: "Descargar backup". Descarga/comparte el ZIP y además lo guarda en la
  // cola, para que no se pierda aunque el técnico nos lo pase por otra vía.
  const handleDescargarBackup = async () => {
    const datos = datosPendientesRef.current;
    if (!datos) return;
    setDescargandoBackup(true);
    try {
      let backup = backupRef.current;
      // Si aún no estaba listo (p. ej. tardó en generarse), lo construimos ahora.
      if (!backup) {
        const entry = construirEntryBackup(datos);
        backup = await construirBackupBlob(entry, ultimoResultadoRef.current);
      }
      // La descarga/compartir debe salir del gesto: se llama sin await previo a share.
      await descargarBlobLocal(backup.blob, backup.filename);
      // Además, lo guardamos en la cola para no perderlo.
      try {
        await guardarEnCola(datos);
      } catch (e) {
        console.error("Error guardando en la cola tras descargar el backup:", e);
      }
      setColaModalOpen(false);
      toast.info(
        t("visitForm.toast.backupDownloaded", {
          defaultValue:
            "Backup descargado. También se ha guardado en la cola para reintentarlo automáticamente.",
        })
      );
      // Retrasamos la navegación para que dé tiempo a ver el toast antes de
      // salir de la pantalla (en iPhone el share sheet consume el tiempo del
      // toast, así que la cuenta empieza al cerrarlo).
      setTimeout(() => {
        window.history.back();
      }, 3000);
    } catch (e) {
      console.error("Error descargando el backup de la visita:", e);
      toast.error(
        t("visitForm.toast.backupError", {
          defaultValue: "No se pudo generar el backup.",
        })
      );
    } finally {
      setDescargandoBackup(false);
    }
  };

  // Procesa la respuesta del servidor. Devuelve true si el resultado es terminal
  // (no hace falta ofrecer la cola); false si conviene ofrecer encolar (red/5xx).
  const procesarRespuesta = (res, toastInfo) => {
    const { nif, id, idCentroTrabajo } = props.params;
    const r = clasificarRespuestaVisita(res);

    if (r.tipo === "exito") {
      finalizarExito(toastInfo);
      return true;
    }

    if (r.tipo === "cliente") {
      // Fallo de cliente (4xx): se muestra el error directamente, NO se encola
      // (reintentar no lo resolvería). Ej.: 409 "ya existe", 404 "no se encuentra".
      if (r.code === 409) {
        // Ya existe en el servidor: limpiamos borrador (IndexedDB) y cola.
        deleteDraft(obtenerStorageKey(nif, id, idCentroTrabajo));
        removeEntry(obtenerStorageKey(nif, id, idCentroTrabajo));
      }
      toast.update(toastInfo, {
        render: r.error.message,
        type: toast.TYPE.ERROR,
        autoClose: true,
      });
      return true;
    }

    // Error de red o de servidor (5xx) → ofrecemos el modal
    // (reintentar / guardar en cola / descargar backup). Guardamos el
    // resultado para incluir el detalle del fallo en el backup.
    ultimoResultadoRef.current = r;
    return false;
  };

  const handleSubmit = async () => {
    if (!validateForm()) {
      toast.error(t('visitForm.validation.completeRequiredFields'));
      return;
    }
    const requiredFields = ["comentarios", "numeroPlantas", "fechaVisita"];
    const emptyFields = requiredFields.filter((key) => !formData[key]);
    if (emptyFields.length > 0) {
      toast.error(t('visitForm.validation.fillAllFields'));
      return;
    }
    if (verificarFecha(formData.fechaVisita) === false) {
      toast.error(t('visitForm.validation.invalidDateFuture'));
      return;
    }

    const datos = construirDatos();
    datosPendientesRef.current = datos;

    // Sin conexión: ofrecemos directamente el modal (reintentar / cola / backup).
    if (navigator.onLine === false) {
      ultimoResultadoRef.current = {
        tipo: "red",
        code: null,
        error: { kind: "network", status: null, message: "Sin conexión / error de red" },
      };
      prepararBackup(datos);
      setColaModalOpen(true);
      return;
    }

    setLoadingSubmit(true);
    const toastInfo = toast.info(t('visitForm.toast.savingData'), { autoClose: false });
    let res;
    try {
      res = await enviarAlServidor(datos);
    } catch (err) {
      res = undefined;
    }
    setLoadingSubmit(false);

    const terminal = procesarRespuesta(res, toastInfo);
    if (!terminal) {
      // Error de red o de servidor: preparamos el backup y mostramos el modal.
      toast.dismiss(toastInfo);
      prepararBackup(datos);
      setColaModalOpen(true);
    }
  };

  // Modal: "Reintentar ahora".
  const handleReintentarAhora = async () => {
    const datos = datosPendientesRef.current;
    if (!datos) return;
    setReintentando(true);
    const toastInfo = toast.info(t('visitForm.toast.savingData'), { autoClose: false });
    let res;
    try {
      res = await enviarAlServidor(datos);
    } catch (err) {
      res = undefined;
    }
    setReintentando(false);
    const terminal = procesarRespuesta(res, toastInfo);
    if (terminal) {
      setColaModalOpen(false);
    } else {
      // Sigue fallando: refrescamos el backup y mantenemos el modal abierto.
      prepararBackup(datos);
      toast.update(toastInfo, {
        render: t('visitForm.toast.stillFailing', {
          defaultValue:
            'Sigue sin poder enviarse. Puedes guardarlo en la cola y se reintentará automáticamente.',
        }),
        type: toast.TYPE.ERROR,
        autoClose: true,
      });
    }
  };

  const handleGuardarEnCola = async () => {
    const datos = datosPendientesRef.current;
    if (!datos) return;
    setReintentando(true);
    try {
      await guardarEnCola(datos);
      setColaModalOpen(false);
      toast.info(
        t('visitForm.toast.queued', {
          defaultValue:
            'La hoja de visita se ha guardado en la cola y se reintentará automáticamente.',
        })
      );
      window.history.back();
    } catch (errEnqueue) {
      console.error('Error encolando la hoja de visita:', errEnqueue);
      toast.error(t('visitForm.toast.dataSaveError'));
    } finally {
      setReintentando(false);
    }
  };

  const addImagesToDelete = (image) => {
    const imgElement = document.querySelector(`.img-${image.indice}`);
    if (imgElement) {
      const nuevosDatos = imagenesUrl.filter(
        (item) => item.indice !== image.indice
      );
      const l = [...imagenesComunidad];
      l.splice(image.indice, 1);
      // const nuevosimagenesComunidad = l.splice(image.indice, 1);
      // const a = [...nuevosimagenesComunidad]
      setImagenesComunidad(l);
      setImagenesUrl(nuevosDatos);
      setTimeout(() => {
        imgElement.remove();
        setImagesToDelete((prevs) => [
          ...prevs,
          { indice: image.indice, id: image.id, path: image.img },
        ]);
      }, 3000);
    }
  };

  return (
    <>
      <Box className="pageHeader" sx={{ backgroundColor: "#f6f7fb" }}>
        <Typography variant="h4" color="#212529" fontWeight={"bold"}>
          {t('documents.visitSheet')}
        </Typography>
      </Box>
      <Box className="pageContent comunidad-container centered" sx={{ p: 3 }}>
        <Typography
          variant="h6"
          color="#212529"
          fontWeight={"bold"}
          sx={{ mb: 4 }}
        >
          {t('details.communityData')}
        </Typography>

        <Box className="lae-flex lae-flex-row lae-flex-between" sx={{ mb: 2 }}>
          <Box
            className="lae-flex lae-flex-column"
            sx={{
              flex: 1,
            }}
          >
            <Box className="lae-flex lae-flex-row">
              <TextField
                id="outlined-select-currency"
                select
                label={t('visitForm.buildingType')}
                value={formData.tipo_edificio}
                /* helperText="Seleccione el tipo de edificio" */
                fullWidth
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    tipo_edificio: e.target.value,
                  }))
                }
              >
                {getTiposEdificio(t).map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </TextField>
              <TextField
                id="outlined-select-community"
                label={
                  props.params.idCentroTrabajo
                    ? t('workCenter.title')
                    : t('titleSingular')
                }
                fullWidth
                value={formData.comunidad}
                disabled
                // defaultValue={formData.comunidad}
              ></TextField>
            </Box>
            <Box className="lae-flex lae-flex-row">
              <TextField
                type="number"
                id="outlined-select-plantas-number"
                label={t('visitForm.numFloors')}
                required
                fullWidth
                value={formData.numeroPlantas}
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    numeroPlantas: e.target.value,
                  }))
                }
                error={!!formErrors.numeroPlantas}
                helperText={formErrors.numeroPlantas}
              ></TextField>
              <TextField
                id="outlined-select-tecnico-prl"
                label={t('visitForm.technicianPrl')}
                fullWidth
                value={formData.tecnicoPRL}
                disabled
                style={{ webkitTextFillColor: "rgba(0, 0, 0, 0.8)" }}
                // defaultValue={formData.comunidad}
              ></TextField>
            </Box>

            <TextField
              id="outlined-select-date"
              type="date"
              label={t('visitForm.visitDate')}
              variant="outlined"
              value={formData.fechaVisita}
              onChange={(e) =>
                setFormData((prev) => ({
                  ...prev,
                  fechaVisita: e.target.value,
                }))
              }
              inputProps={{
                "aria-label": "controlled",
              }}
              InputLabelProps={{
                shrink: true,
              }}
            ></TextField>
            {!props.params.idCentroTrabajo && 
              <Portales 
                prop_id={finca.id} 
                formData={formData.portales} 
                setFormData={setFormData}
                error={{
                  portales: formErrors.portales,
                  portalesErrors: formErrors.portalesErrors
                }}
              />
            }
          </Box>
          <Box
            className="lae-flex lae-flex-column pos-relative"
            sx={{
              flex: 1,
            }}
          >
            <Box sx={{
              opacity: procesandoImagenes ? 0.5 : 1,
              pointerEvents: procesandoImagenes ? 'none' : 'auto',
              filter: procesandoImagenes ? 'grayscale(50%)' : 'none',
              transition: 'all 0.3s ease'
            }}>
              <DragNDrop
                onUpload={(files) => {
                  handleUploadImg(files);
                }}
                count={1}
                formats={["jpeg", "jpg", "png", "svg", "webp"]}
                label={
                  <Typography variant="caption">{t('visitForm.communityImage')}</Typography>
                }
                title={t('visitForm.dropOrSelectFile')}
                openDialogOnClick={false}
                disabled={procesandoImagenes}
              >
                <Box sx={{ display: 'flex', flexDirection: 'row', gap: 0 }}>
                  <input
                    ref={cameraInputRef}
                    type="file"
                    accept="image/*"
                    capture="environment"
                    style={{ display: 'none' }}
                    onChange={(e) => {
                      const files = [...e.target.files];
                      if (files.length > 0) handleUploadImg(files);
                      e.target.value = '';
                    }}
                  />
                  <input
                    ref={fileInputRef}
                    type="file"
                    accept="image/*"
                    style={{ display: 'none' }}
                    onChange={(e) => {
                      const files = [...e.target.files];
                      if (files.length > 0) handleUploadImg(files);
                      e.target.value = '';
                    }}
                  />
                  <Button
                    variant="outlined"
                    onClick={() => cameraInputRef.current?.click()}
                    disabled={procesandoImagenes}
                    sx={{
                      flex: 1,
                      minHeight: 80,
                      borderColor: '#c3c3c3',
                      borderStyle: 'dashed',
                      borderRadius: '4px 0 0 4px',
                      borderRight: 'none',
                      color: '#92004D',
                      backgroundColor: '#faf5f8',
                      textTransform: 'none',
                      display: 'flex',
                      flexDirection: 'column',
                      gap: 0.5,
                      fontSize: 13,
                      fontWeight: 500,
                      '&:hover': { backgroundColor: '#f0e0ea', borderColor: '#92004D', borderStyle: 'dashed', borderRight: 'none' },
                    }}
                  >
                    <MdCameraAlt size={28} />
                    {t('visitForm.takePhoto')}
                  </Button>
                  <Button
                    variant="outlined"
                    onClick={() => fileInputRef.current?.click()}
                    disabled={procesandoImagenes}
                    sx={{
                      flex: 1,
                      minHeight: 80,
                      borderColor: '#c3c3c3',
                      borderStyle: 'dashed',
                      borderRadius: '0 4px 4px 0',
                      color: '#92004D',
                      backgroundColor: '#faf5f8',
                      textTransform: 'none',
                      display: 'flex',
                      flexDirection: 'column',
                      gap: 0.5,
                      fontSize: 13,
                      fontWeight: 500,
                      '&:hover': { backgroundColor: '#f0e0ea', borderColor: '#92004D', borderStyle: 'dashed' },
                    }}
                  >
                    <ImAttachment size={24} />
                    {t('visitForm.selectFile')}
                  </Button>
                </Box>
              </DragNDrop>
            </Box>
            {restaurandoImagenes && (
              <Box
                sx={{
                  my: 2,
                  p: 2,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 1,
                  color: "#92004D",
                }}
              >
                <CircularProgress size={20} sx={{ color: "#92004D" }} />
                <Typography variant="body2" sx={{ color: "#92004D", fontWeight: 600 }}>
                  {t('visitForm.restoringImages', {
                    defaultValue: 'Cargando imágenes guardadas...',
                  })}
                </Typography>
              </Box>
            )}

            {imagenUrl !== null && (
              <img
                src={imagenUrl}
                alt={t('visitForm.mainImage')}
                style={{
                  maxWidth: "100%",
                  height: "350px",
                  objectFit: "cover",
                }}
              />
            )}

            {procesandoImagenes && (
              <Box 
                sx={{ 
                  mb: 2, 
                  p: 2, 
                  backgroundColor: "#f0f8ff", 
                  border: "1px solid #92004D", 
                  borderRadius: "8px",
                  textAlign: "center"
                }}
              >
                <Typography 
                  variant="body1" 
                  sx={{ 
                    color: "#92004D", 
                    fontWeight: "bold",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 1
                  }}
                >
                  <CircularProgress size={20} sx={{ color: "#92004D" }} />
                  {t('visitForm.compressingImages')}
                </Typography>
              </Box>
            )}
            <Box sx={{
              opacity: procesandoImagenes ? 0.5 : 1,
              pointerEvents: procesandoImagenes ? 'none' : 'auto',
              filter: procesandoImagenes ? 'grayscale(50%)' : 'none',
              transition: 'all 0.3s ease'
            }}>
              <DragNDrop
                onUpload={(files) => handleUploadImgs(files)}
                count={20}
                formats={["jpeg", "jpg", "png", "svg", "webp"]}
                label={
                  <Typography variant="caption">{t('visitForm.riskImages')}</Typography>
                }
                title={t('visitForm.dropOrSelectImages')}
                openDialogOnClick={false}
                disabled={procesandoImagenes}
              >
                <Box sx={{ display: 'flex', flexDirection: 'row', gap: 0 }}>
                  <input
                    ref={cameraInputMultiRef}
                    type="file"
                    accept="image/*"
                    capture="environment"
                    style={{ display: 'none' }}
                    onChange={(e) => {
                      const files = [...e.target.files];
                      if (files.length > 0) handleUploadImgs(files);
                      e.target.value = '';
                    }}
                  />
                  <input
                    ref={fileInputMultiRef}
                    type="file"
                    accept="image/*"
                    multiple
                    style={{ display: 'none' }}
                    onChange={(e) => {
                      const files = [...e.target.files];
                      if (files.length > 0) handleUploadImgs(files);
                      e.target.value = '';
                    }}
                  />
                  <Button
                    variant="outlined"
                    onClick={() => cameraInputMultiRef.current?.click()}
                    disabled={procesandoImagenes}
                    sx={{
                      flex: 1,
                      minHeight: 80,
                      borderColor: '#c3c3c3',
                      borderStyle: 'dashed',
                      borderRadius: '4px 0 0 4px',
                      borderRight: 'none',
                      color: '#92004D',
                      backgroundColor: '#faf5f8',
                      textTransform: 'none',
                      display: 'flex',
                      flexDirection: 'column',
                      gap: 0.5,
                      fontSize: 13,
                      fontWeight: 500,
                      '&:hover': { backgroundColor: '#f0e0ea', borderColor: '#92004D', borderStyle: 'dashed', borderRight: 'none' },
                    }}
                  >
                    <MdCameraAlt size={28} />
                    {t('visitForm.takePhoto')}
                  </Button>
                  <Button
                    variant="outlined"
                    onClick={() => fileInputMultiRef.current?.click()}
                    disabled={procesandoImagenes}
                    sx={{
                      flex: 1,
                      minHeight: 80,
                      borderColor: '#c3c3c3',
                      borderStyle: 'dashed',
                      borderRadius: '0 4px 4px 0',
                      color: '#92004D',
                      backgroundColor: '#faf5f8',
                      textTransform: 'none',
                      display: 'flex',
                      flexDirection: 'column',
                      gap: 0.5,
                      fontSize: 13,
                      fontWeight: 500,
                      '&:hover': { backgroundColor: '#f0e0ea', borderColor: '#92004D', borderStyle: 'dashed' },
                    }}
                  >
                    <ImAttachment size={24} />
                    {t('visitForm.selectFile')}
                  </Button>
                </Box>
              </DragNDrop>
            </Box>
            <Box>
              <CustomImageList
                imgs={imagenesUrl}
                addImagesToDelete={addImagesToDelete}
              />
              {/* {imagenesUrl.map((imageUrl, index) => (
                <img key={index} src={imageUrl} alt={`Imagen ${index + 1}`} style={{ maxWidth: '100%', width:'150px' }} />
              ))} */}
            </Box>
          </Box>
        </Box>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <TextField
            id="outlined-multiline-static"
            label={t('visitForm.additionalComments')}
            multiline
            required
            rows={12}
            // placeholder="Escribe algo..."
            value={formData.comentarios}
            sx={{ width: "100%", alignSelf: "center", my: 2 }}
            onChange={(e) =>
              setFormData((prev) => ({
                ...prev,
                comentarios: e.target.value,
              }))
            }
            error={!!formErrors.comentarios}
            helperText={formErrors.comentarios}
          />
          <Typography
            variant="h6"
            color="#212529"
            fontWeight={"bold"}
            sx={{ mb: 4 }}
          >
            {t('visitForm.buildingRisks')}
          </Typography>
          {statement.filter((s) => formData.tipo_edificio !== "garaje" || s.codigo === 4).map((s) => {
            return (
              <Box
                className="lae-flex lae-flex-row lae-flex-betweeen"
                key={s.id}
              >
                <Box
                  // className="lae-flex lae-flex-row"
                  sx={{ flex: 1, alignItems: "start" }}
                >
                  <SubQuestion
                    key={s.id}
                    question={`${s.codigo}.- ${s.pregunta}`}
                    checkBind={formData?.questions[s.id]?.respuesta}
                    t={t}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        questions: {
                          ...prev?.questions,
                          [s.id]: {
                            ...prev?.questions?.[s.id],
                            statements_id: s.id,
                            respuesta: e.target.checked,
                            subquestions:
                              e.target.checked === "si"
                                ? s.subpreguntas.reduce((subAcc, subPreg) => {
                                    subAcc[subPreg.id] = {
                                      statements_id: subPreg.id,
                                      respuesta: undefined,
                                    };
                                    return subAcc;
                                  }, {})
                                : {},
                          },
                        },
                        // p1_0: e.target.checked === "true" ? "si" : "no",
                      }))
                    }
                    noTakes={s.noProcede ? true : false}
                  />
                </Box>
                {(formData?.questions[s.id]?.respuesta === "si" ||
                  s.codigo === 1) && (
                  <Box
                    className="lae-flex lae-flex-column"
                    sx={{
                      flex: 1,
                      p: 2,
                      boxShadow: "0px 0.1px 3px rgba(0, 0, 0, 0.1)",
                      backgroundColor: "rgb(229 216 216 / 10%)",
                      borderRadius: "10px",
                    }}
                  >
                    {s.subpreguntas.map((p) => {
                      if (
                        formData?.questions[s.id]?.subquestions[p.id]
                          ?.statements_id == 15 &&
                        (formData?.questions[s.id]?.subquestions[p.id]
                          ?.respuesta === "si" ||
                          formData?.questions[s.id]?.subquestions[p.id]
                            ?.respuesta === undefined)
                      ) {
                        esPregunta15Si = true;
                      }
                      if (
                        formData?.questions[s.id]?.subquestions[p.id]
                          ?.statements_id == 15 &&
                        formData?.questions[s.id]?.subquestions[p.id]
                          ?.respuesta == "no"
                      ) {
                        esPregunta15Si = false;
                      }

                      if (
                        esPregunta15Si &&
                        (formData?.questions[s.id]?.subquestions[p.id]
                          ?.statements_id == 16 ||
                          formData?.questions[s.id]?.subquestions[p.id]
                            ?.statements_id == 17 ||
                          formData?.questions[s.id]?.subquestions[p.id]
                            ?.statements_id == 18)
                      ) {
                        formData.questions[s.id].subquestions[p.id].respuesta =
                          "null";
                        return null;
                      }
                      // si la pregunta 5_1 es si que muestre la pregunta 5_2 y la 5_3 no
                      if (
                        formData?.questions[s.id]?.subquestions[p.id]
                          ?.statements_id == 43 &&
                        (formData?.questions[s.id]?.subquestions[p.id]
                          ?.respuesta == "no" ||
                          formData?.questions[s.id]?.subquestions[p.id]
                            ?.respuesta === undefined)
                      ) {
                        esPregunta5_1Si = true;
                      }
                      if (
                        formData?.questions[s.id]?.subquestions[p.id]
                          ?.statements_id == 43 &&
                        formData?.questions[s.id]?.subquestions[p.id]
                          ?.respuesta == "si"
                      ) {
                        esPregunta5_1Si = false;
                      }
                      if (
                        esPregunta5_1Si &&
                        (formData?.questions[s.id]?.subquestions[p.id]
                          ?.statements_id == 44 ||
                          formData?.questions[s.id]?.subquestions[p.id]
                            ?.statements_id == 45)
                      ) {
                        formData.questions[s.id].subquestions[p.id].respuesta =
                          "null";
                        return null;
                      }
                      // si la pregunta 5_2 es si que muestre la pregunta 5_3
                      if (
                        formData?.questions[s.id]?.subquestions[p.id]
                          ?.statements_id == 44 &&
                        (formData?.questions[s.id]?.subquestions[p.id]
                          ?.respuesta == "no" ||
                          formData?.questions[s.id]?.subquestions[p.id]
                            ?.respuesta === undefined ||
                          formData?.questions[s.id]?.subquestions[p.id]
                            ?.respuesta === "null")
                      ) {
                        esPregunta5_2Si = true;
                      }
                      if (
                        formData?.questions[s.id]?.subquestions[p.id]
                          ?.statements_id == 44 &&
                        formData?.questions[s.id]?.subquestions[p.id]
                          ?.respuesta == "si"
                      ) {
                        esPregunta5_2Si = false;
                      }
                      if (
                        !esPregunta5_1Si &&
                        esPregunta5_2Si &&
                        formData?.questions[s.id]?.subquestions[p.id]
                          ?.statements_id == 45
                      ) {
                        formData.questions[s.id].subquestions[p.id].respuesta =
                          "null";
                        return null;
                      }
                      return (
                        <SubQuestion
                          question={`${p.codigo}.${p.subcodigo}.- ${p.pregunta}`}
                          checkBind={
                            formData?.questions[s.id]?.subquestions[p.id]
                              ?.respuesta
                          }
                          noTakes={p.noProcede ? true : false}
                          t={t}
                          onChange={(e) =>
                            setFormData((prev) => ({
                              ...prev,
                              ...prev,
                              questions: {
                                ...prev?.questions,
                                [s.id]: {
                                  ...prev?.questions?.[s.id],
                                  subquestions: {
                                    ...prev?.questions?.[s.id]?.subquestions,
                                    [p.id]: {
                                      ...prev?.questions?.[s.id]
                                        ?.subquestions?.[p.id],
                                      statements_id: p.id,
                                      respuesta: e.target.checked,
                                    },
                                  },
                                },
                              },
                            }))
                          }
                        />
                      );
                    })}
                  </Box>
                )}
              </Box>
            );
          })}

          <ColorButton
            sx={{ alignSelf: "center", width: "80%" }}
            onClick={handleSubmit}
            disabled={loadingSubmit || procesandoImagenes}
          >
            {loadingSubmit || procesandoImagenes ? (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <CircularProgress size={24} sx={{ color: "#92004d" }} />
                {procesandoImagenes ? t('visitForm.processingImages') : t('common:status.loading')}
              </Box>
            ) : (
              t('visitForm.saveAndSend')
            )}
          </ColorButton>
        </Box>
      </Box>
      <Dialog
        open={colaModalOpen}
        onClose={() => !reintentando && !descargandoBackup && setColaModalOpen(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle sx={{ fontWeight: "bold", color: "#212529" }}>
          {t('visitForm.queueModal.title', {
            defaultValue: 'No se ha podido enviar',
          })}
        </DialogTitle>
        <DialogContent>
          <DialogContentText sx={{ color: "#555" }}>
            {t('visitForm.queueModal.message', {
              defaultValue:
                'No se ha podido enviar la hoja de visita. Puedes reintentarlo ahora, guardarlo en la cola (se reintentará automáticamente y podrás verlo en "Cola de visitas") o descargar un backup para reenviárnoslo por otra vía.',
            })}
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ p: 2, flexDirection: "column", gap: 1 }}>
          <Button
            onClick={handleReintentarAhora}
            disabled={reintentando || descargandoBackup}
            variant="outlined"
            fullWidth
            sx={{
              color: "#92004D",
              borderColor: "#92004D",
              "&:hover": { borderColor: "#7a0040", backgroundColor: "#faf5f8" },
            }}
          >
            {reintentando ? (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <CircularProgress size={18} sx={{ color: "#92004D" }} />
                {t('common:status.loading')}
              </Box>
            ) : (
              t('visitForm.queueModal.retryNow', { defaultValue: 'Reintentar ahora' })
            )}
          </Button>
          <ColorButton
            onClick={handleGuardarEnCola}
            disabled={reintentando || descargandoBackup}
            fullWidth
          >
            {t('visitForm.queueModal.saveToQueue', { defaultValue: 'Guardar en la cola' })}
          </ColorButton>
          <Button
            onClick={handleDescargarBackup}
            disabled={reintentando || descargandoBackup || backupPreparando}
            variant="outlined"
            fullWidth
            startIcon={
              descargandoBackup || backupPreparando ? null : (
                <MdFileDownload size={20} />
              )
            }
            sx={{
              color: "#92004D",
              borderColor: "#92004D",
              borderStyle: "dashed",
              textTransform: "none",
              fontWeight: 600,
              "&:hover": {
                borderColor: "#7a0040",
                borderStyle: "dashed",
                backgroundColor: "#faf5f8",
              },
            }}
          >
            {descargandoBackup || backupPreparando ? (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <CircularProgress size={18} sx={{ color: "#92004D" }} />
                {backupPreparando
                  ? t('visitForm.queueModal.preparingBackup', { defaultValue: 'Preparando backup…' })
                  : t('common:status.loading')}
              </Box>
            ) : (
              <Box sx={{ display: 'flex', flexDirection: 'column', lineHeight: 1.2 }}>
                <span>
                  {t('visitForm.queueModal.downloadBackup', {
                    defaultValue: 'Descargar backup',
                  })}
                </span>
                <Box
                  component="span"
                  sx={{ fontSize: '0.7rem', fontWeight: 400, opacity: 0.85 }}
                >
                  {t('visitForm.queueModal.downloadBackupHint', {
                    defaultValue: '(y guardar en la cola)',
                  })}
                </Box>
              </Box>
            )}
          </Button>
        </DialogActions>
      </Dialog>
      <style jsx>{`
        .css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input.Mui-disabled {
          -webkit-text-fill-color: rgba(0, 0, 0, 0.8);
        }
      `}</style>
    </>
  );
}

export default withRouter(Comunidad);
